import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  PoDialogService,
  PoNotificationService,
  PoTableAction,
  PoTableColumn,
} from "@po-ui/ng-components";
import { AreaTecnicaAdminService } from "./areatecadmin.service";

@Component({
  selector: "app-ordemcoleta", // Considere renomear este seletor para algo mais relacionado ao componente, como 'app-area-tecnica-admin'
  templateUrl: "./areatecadmin.component.html",
  styleUrls: ["./areatecadmin.component.css"],
  standalone: false,
})
export class AreaTecnicaAdminComponent implements OnInit {
  constructor(
    private areaTecnicaAdminService: AreaTecnicaAdminService,
    private router: Router,
    private poNotification: PoNotificationService,
    private poAlert: PoDialogService
  ) { }

  columnsProdutos: Array<PoTableColumn>;
  columnsSimilar: Array<PoTableColumn>;
  columnsAcervo: Array<PoTableColumn>; // Colunas da tabela do acervo
  itemsSimilar: Array<any> = new Array(); // Inicialize como um array vazio []
  itemsProdutos: Array<any> = new Array(); // Inicialize como um array vazio []
  itemsAcervo: Array<any> = new Array(); // Array que a po-table vai exibir, inicialize como um array vazio []
  isPecas: boolean;
  produtoItems: Array<any>;
  segmento: string;
  produtoFiltro: string;
  optionsProdutos: Array<any> = new Array();
  isHideLoading: boolean; // Flag para controlar o overlay de carregamento
  comboSeguimento: string; // Valor selecionado no po-select
  titulo: string;
  descricao: string;
  link: string;
  AdcionarAlterar: string;
  messageDialog: string;
  isAdd: boolean;
  id: number;

  ngOnInit() {
    this.columnsAcervo = this.areaTecnicaAdminService.getAcervoColumns();
    this.isPecas = sessionStorage.getItem("Segmento") === "PECAS";
    this.AdcionarAlterar = "Adcionar";
    this.comboSeguimento = this.isPecas ? 'PECAS' : 'MOTOS';
    this.isAdd = false;
    this.getAcervo();
  }

  selectItem(row: any) {
    this.AdcionarAlterar = "Alterar";
    this.titulo = row.titulo;
    this.link = row.link;
    this.descricao = row.descricao;
    this.id = row.id;
    this.isAdd = true;
  }

  unselectItem(row: any) {
    this.id = null;
    this.titulo = "";
    this.link = "";
    this.descricao = "";
    this.AdcionarAlterar = "Adcionar";
    this.isAdd = false;
  }

  getAcervo() {
    this.isHideLoading = false;
    this.itemsAcervo = [];
    this.id = null;
    this.titulo = "";
    this.link = "";
    this.descricao = "";
    this.AdcionarAlterar = "Adcionar";
    this.isAdd = false;

    let items = []

    this.areaTecnicaAdminService.getAcervos(this.comboSeguimento).subscribe({
      next: (acervo) => {
        if (Array.isArray(acervo)) {
          for (let item of acervo) {
            items.push({
              id: item.id,
              titulo: item.titulo,
              descricao: item.descricao,
              link: item.link,
            });
          }
        } else {
          console.warn('O serviço getAcervos não retornou um array:', acervo);
          this.poNotification.warning('Formato de dados inesperado ao carregar acervos.');
        }
        this.isHideLoading = true;
      },
      error: (err) => {
        console.error('Erro ao carregar acervos:', err);
        this.poNotification.error('Erro ao carregar acervos.');
        this.isHideLoading = true;
      },
      complete: () => {
        this.itemsAcervo = items
        console.table(this.itemsAcervo)
      }
    });
  }

  adcionar() {
    if (!this.isAdd) {
      this.poAlert.confirm({
        title: "Incluir?",
        message: "Confirma inclusão?",
        confirm: () => {
          this.isHideLoading = false;
          this.areaTecnicaAdminService
            .putAcervos(
              this.comboSeguimento,
              this.titulo,
              this.link,
              this.descricao
            )
            .subscribe({
              next: (resposta) => {
                this.poNotification.success(resposta.status);
                this.getAcervo();
              },
              error: (err) => {
                console.error('Erro ao adicionar acervo:', err);
                this.poNotification.error('Erro ao adicionar acervo.');
                this.isHideLoading = true;
              }
            });
        },
        cancel: () => { },
      });
    } else {
      this.poAlert.confirm({
        title: "Alterar?",
        message: "Confirma alteração?",
        confirm: () => {
          this.isHideLoading = false;
          this.areaTecnicaAdminService
            .updateAcervos(
              this.id,
              this.comboSeguimento,
              this.titulo,
              this.link,
              this.descricao
            )
            .subscribe({
              next: (resposta) => {
                this.poNotification.success(resposta.status);
                this.getAcervo();
              },
              error: (err) => {
                console.error('Erro ao alterar acervo:', err);
                this.poNotification.error('Erro ao alterar acervo.');
                this.isHideLoading = true;
              }
            });
        },
        cancel: () => { },
      });
    }
  }

  remover(row: any) {
    this.poAlert.confirm({
      title: "Excluir?",
      message: "Confirma exclusão?",
      confirm: () => {
        this.isHideLoading = false;
        this.areaTecnicaAdminService
          // Passando o ID do item a ser excluído e o segmento atual
          .deletAcervos(row.id, this.comboSeguimento)
          .subscribe({
            next: (resposta) => {
              this.poNotification.success(resposta.status);
              // reset fields
              this.id = null;
              this.titulo = "";
              this.link = "";
              this.descricao = "";
              this.AdcionarAlterar = "Adcionar";
              this.getAcervo(); // Recarrega a tabela após a exclusão
            },
            error: (err) => {
              console.error('Erro ao excluir acervo:', err);
              this.poNotification.error('Erro ao excluir acervo.');
              this.isHideLoading = true; // Esconde o loading em caso de erro
            }
          });
      },
      cancel: () => { },
    });
  }

  actions: Array<PoTableAction> = [
    {
      action: this.remover.bind(this),
      icon: "po-icon po-icon-delete",
      label: "Excluir",
    },
    // Adicione uma ação de 'Editar' se desejar, que chamaria 'selectItem'
    // {
    //   action: (row: any) => this.selectItem(row),
    //   icon: "po-icon po-icon-edit",
    //   label: "Editar",
    // },
  ];
}